<template>
  <div v-if="updateAvailable" class="aviso-version" role="status" aria-live="polite"
       data-test="aviso-nueva-version">
    <span class="aviso-version__texto">
      <i class="bi bi-arrow-repeat" aria-hidden="true"></i>
      Hay una nueva versión del sistema
    </span>
    <button type="button" class="aviso-version__boton" :disabled="preguntando"
            data-test="btn-actualizar-version" @click="onActualizar">
      ACTUALIZAR A LA ÚLTIMA VERSIÓN
    </button>
  </div>
</template>

<script setup>
// Aviso no modal: la recarga sólo ocurre si el operador confirma (RN-172,
// SPEC_AVISO_NUEVA_VERSION_v0.1.md). Abajo a la izquierda y con `z-index: 1040`:
// por debajo de notificaciones, modales y confirm, así que nunca tapa un
// diálogo (PA-4).
import { ref } from 'vue'
import { updateAvailable, applyUpdate } from '@/services/appVersionService'

const preguntando = ref(false)

const onActualizar = async () => {
  preguntando.value = true
  try {
    // `await`: el confirm de la app devuelve una PROMESA (H-ZC1). Sin esperarla,
    // «No, más tarde» recargaría igual.
    const ok = await window.confirm('La página se va a recargar con la última versión del sistema.', {
      title: '¿Actualizar ahora?',
      confirmText: 'Sí, actualizar',
      cancelText: 'No, más tarde'
    })
    if (ok) await applyUpdate()
  } finally {
    preguntando.value = false
  }
}
</script>

<style scoped>
.aviso-version {
  position: fixed;
  left: max(1rem, env(safe-area-inset-left, 0px));
  bottom: max(1rem, env(safe-area-inset-bottom, 0px));
  z-index: 1040;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  max-width: calc(100vw - 2rem);
  padding: 0.55rem 0.75rem;
  border-radius: var(--vx-radio, 8px);
  background: var(--vx-acento, #07a7e1);
  color: #ffffff;
  font-size: 0.9rem;
  box-shadow: var(--vx-sombra, 0 6px 20px rgba(19, 47, 58, 0.08)), 0 2px 6px rgba(19, 47, 58, 0.18);
}

.aviso-version__texto {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 550;
}

.aviso-version__boton {
  height: var(--vx-control-sm, 32px);
  padding: 0 0.8rem;
  font-size: 12.5px;
  font-weight: 650;
  letter-spacing: 0.02em;
  color: var(--vx-acento-oscuro, #0b7fa8);
  background: #ffffff;
  border: 0;
  border-radius: var(--vx-radio-sm, 6px);
  cursor: pointer;
}

.aviso-version__boton:hover:not(:disabled) { background: rgba(255, 255, 255, 0.88); }
.aviso-version__boton:disabled { opacity: 0.7; cursor: wait; }
.aviso-version__boton:focus-visible { outline: 2px solid #ffffff; outline-offset: 2px; }

@media print {
  .aviso-version { display: none; }
}
</style>
